import {Label} from './Label';
import {InformationType} from './InformationType';
import {FaqCategory} from './FaqCategory';
import {CommonObject} from './common-object';

export class Information extends CommonObject {
  title = '';
  description = '';
  publication = undefined;
  endDate = undefined;
  type = InformationType.DIRECT;
  labels: Label[] = [];
  categories: FaqCategory[] = [];
  draft = false;

  static compare(a, b): number {
    if (a.draft !== b.draft) {
      // If info is draft, it should be after the others
      return a.draft ? 1 : -1;
    } else {
      // Sort by publication date, most recent first
      return (a.publication === b.publication) ? 0 : a.publication < b.publication ? 1 : -1;
    }
  }
}
